import { getAllSales } from '../../api/salesApi'
import EditAdminSalesModal from './editAdminSalesModal';
import GenericSalesList from '../common/genericSalesList';

export default function AdminSalesList() {

    return (
        <GenericSalesList
            fetchDataApi={() => getAllSales()}
            ModalComponent={EditAdminSalesModal}
        />
    );
}